<template>
  <div>
    <q-dialog v-if="propostaConfirmarBanco" v-model="modalConfirmacao" persistent>
        <q-card style="width: 700px; max-width: 80vw;">
          <q-card-section>
            <div class="text-h6">Confirmação da Operação</div>
          </q-card-section>
          <q-card-section v-if="propostaConfirmarBanco.tipoProposta === 2" class="q-pt-none">
            Proposta Selecionada: Pagamento mensal de 100% do benefício atual e com carência de 2 anos para o início dos reajustes: {{this.$b.fCurrency(this.dadosBeneficiario.acordoParcelado2)}}.
          </q-card-section>
          <q-card-section v-else-if="propostaConfirmarBanco.tipoProposta === 3" class="q-pt-none">
            Proposta Selecionada: Pagamento em parcela única: {{this.$b.fCurrency(this.dadosBeneficiario.parcelaUnica)}} mais benefícios especiais {{this.$b.fCurrency(this.dadosBeneficiario.valorPeculio)}}.
          </q-card-section>
          <q-card-section v-else-if="propostaConfirmarBanco.tipoProposta === 4" class="q-pt-none">
            Proposta Selecionada: Não tenho interesse no acordo.
          </q-card-section>
          <q-card-section  v-if="propostaConfirmarBanco.tipoProposta !== null" class="q-pt-none">
            <div class="row q-gutter-lg q-pr-md q-pb-md">
              <div class="col-xs-12 col-sm-12 col-md-4">
                <q-input  label="Código recebido*" :mask="'###-###'" v-model="codigoVerificador" outlined :dense="true" lazy-rules :rules="[ val => val && val.length > 0 || 'Campo obrigatório']"/>
            </div>
              <div class="col-xs-12 col-sm-12 col-md-2">
                <q-btn :loading="loadingConfirmarCodigo" color="primary" label="Confirmar" @click="confirmarCodigoVerificador" />
            </div>
          </div>
          </q-card-section>

          <q-card-actions align="right" class="bg-white text-teal">
            <q-btn flat label="Fechar" @click="closeModalConfirmacao" />
          </q-card-actions>
        </q-card>
      </q-dialog>
  </div>
</template>

<script>
import CodigoConfirmacao from '@/classes/CodigoConfirmacao'
import SmsService from '@/services/sms'
import OperacaoService from '@/services/operacao'
import FormatNumeroCelular from '@/utils/FormatNumeroCelular'
import ConfirmarProposta from '@/classes/ConfirmarProposta'
export default {
  data () {
    return {
      codigoConfirmacao: new CodigoConfirmacao(),
      confirmarProposta: new ConfirmarProposta(),
      codigoVerificador: null,
      loadingConfirmarCodigo: false
    }
  },
  props: ['dadosBeneficiario', 'propostaConfirmarBanco', 'modalConfirmacao'],
  methods: {
    confirmarCodigoVerificador () {
      if (this.codigoVerificador === null || this.codigoVerificador === '') {
        return this.$b.nWarning('Informe o código verificador')
      }
      if (this.codigoVerificador.length < 7) {
        return this.$b.nWarning('Código Verificador incompleto')
      }
      this.codigoConfirmacao.codigoVerificador = FormatNumeroCelular(this.codigoVerificador)
      this.loadingConfirmarCodigo = true
      SmsService.confirmaCodigoVerificador(this.codigoConfirmacao).then(resposta => {
        if (resposta.data.status === 'ERROR') {
          this.loadingConfirmarCodigo = false
          return this.$b.nError(resposta.data.message)
        }
        this.confirmarProposta = Object.assign({}, this.propostaConfirmarBanco)
        OperacaoService.confirma(this.confirmarProposta).then(resposta => {
          this.loadingConfirmarCodigo = false
          if (resposta.data.status === 'ERROR') {
            return this.$b.nError(resposta.data.message)
          }
          this.$router.push({ name: 'TelaSucesso', params: { responseData: true } })
        }).catch((e) => {
          this.loadingConfirmarCodigo = false
          return this.$b.nError(e)
        })
      }).catch((e) => {
        this.loadingConfirmarCodigo = false
        return this.$b.nError(e)
      })
    },
    closeModalConfirmacao () {
      this.codigoVerificador = null
      this.$emit('closeModalConfirmacao', false)
      this.openModal = null
    }
  }
}

</script>
